// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__k4hLH","title":"ClientCherryInfo_title__3tppO","itemText":"ClientCherryInfo_itemText__JJy_5"};